import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Flex } from '../../layout/Flex.mjs';

const DatePickerContent = ({ children, ...rest }) => {
  return /* @__PURE__ */ jsx(StyledFlexColumn, { direction: "column", align: "start", ...rest, children });
};
const StyledFlexColumn = styled(Flex, {
  width: "100%",
  "> div": {
    width: "100%"
  }
});

export { DatePickerContent as default };
//# sourceMappingURL=Content.mjs.map
